module.exports = __webpack_public_path__ + "static/media/LoginBanner1920X500.7b18f458.png";